<template>
    <v-textarea
      ref="input"
      v-bind="attributes"
      v-on="$listeners"
      @input.native="onInput"
    ></v-textarea>
  </template>
  
  <script>
  import form_mixin from "./form_mixin";
  
  export default {
    name: "z-textarea",
  
    props: {
      upper: {
        type: Boolean,
        default: false,
      },
    },
  
    mixins: [form_mixin],
  
    computed: {
      attributes() {
        return { ...this.$attrs, ...this.$v.TEXT_FIELDS };
      },
    },
  
    methods: {
      onInput(event) {
        if (this.upper || this.lower) {
          let posicao = event.target.selectionStart; // Marca a posição do cursor
          event.target.value = this.transforma(event.target.value);
          event.target.setSelectionRange(posicao, posicao); // Restaura a posição do cursor
        }
  
        this.$emit("input", event.target.value);
      },
  
      transforma(texto = "") {
        if (this.upper && !this.lower && !this.capitalized) {
          return texto.toUpperCase();
        }
  
        if (this.lower && !this.upper && !this.capitalized) {
          return texto.toLowerCase();
        }
  
        return texto;
      },
  
      focus() {
        this.$refs.input.focus();
      },
    },
  };
  </script>
  
  <style scoped>
  </style>
  